import { z } from 'zod';

import {
  filterSchema,
  titleSchema,
} from '../../universal-widget/settingsSchema';

/**
 * Settings for the IndicatorResultsOverTime widget (CUS-143): the shared
 * filtering + custom-title fields plus a per-widget toggle for tolerance /
 * appetite reference lines. `showTolerances` is only surfaced in the modal
 * when the widget is filtered to a single indicator that has tolerances or
 * appetites, but the persisted value is preserved regardless — so the toggle
 * reappears in its prior state when the widget returns to a single-indicator
 * view. Undefined (e.g. a brand-new widget) is treated as off.
 */
export const indicatorResultsOverTimeSettingsSchema = filterSchema
  .and(titleSchema)
  .and(z.object({ showTolerances: z.boolean().optional() }));

export type IndicatorResultsOverTimeSettings = z.infer<
  typeof indicatorResultsOverTimeSettingsSchema
>;
